import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useAuth } from "../../../hooks/auth";
import { useNavigate } from "react-router-dom";
import "../../../components/Feedback/Toast";

import { FaEnvelope, FaLock } from "react-icons/fa";

import { Input } from "../../../components/Form/Input";
import { Auth } from "../../../templates/Auth";
import { createToast } from "../../../components/Feedback/Toast";
import { AuthTitle } from "../../../components/atoms/Text/AuthTitle";
import { AuthSubmitButton } from "../../../components/atoms/Button/AuthSubmitButton";
import { AuthCardForm } from "../../../components/atoms/Card/AuthCardForm";
import { AuthDivider } from "../../../components/atoms/Divider/AuthDivider";
import { AuthStack } from "../../../components/atoms/Stack/AuthStack";
import { useEffect } from "react";

const loginFormSchema = yup.object().shape({
  email: yup.string().required("E-mail obrigatório").email("E-mail inválido"),
  password: yup.string().required("Senha obrigatória"),
});

export function Login() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(loginFormSchema),
  });
  const handleLogin: SubmitHandler<FieldValues> = (values) => {
    signIn({
      email: values.email,
      password: values.password,
    })
      .then((user: any) => {
        navigate("/");

        createToast({
          title: "Login realizado com sucesso",
          status: "success",
        });
      })
      .catch((err) => {
        createToast({
          title: "Não foi possível realizar o login",
          status: "error",
        });
      });
  };

  useEffect(() => {
   window.location.href = "https://financeiro.falae.app/login";
  }, [formState.errors]);

  const { errors } = formState;

  return (
    <Auth>
      <AuthCardForm onSubmit={handleSubmit(handleLogin)}>
        <AuthStack>
          <AuthTitle text="Faça o login para iniciar sua sessão" />
          <Input
            type="email"
            placeholder="E-mail"
            error={errors.email}
            icon={FaEnvelope}
            {...register("email")}
          />
          <Input
            type="password"
            placeholder="Senha"
            icon={FaLock}
            error={errors.password}
            {...register("password")}
          />
        </AuthStack>
        <AuthSubmitButton text="Login" isLoading={formState.isSubmitting} />
        <AuthDivider />
      </AuthCardForm>
    </Auth>
  );
}
